import { render, staticRenderFns } from "./BaseTextField.vue?vue&type=template&id=380fb470&scoped=true"
import script from "./BaseTextField.vue?vue&type=script&lang=js"
export * from "./BaseTextField.vue?vue&type=script&lang=js"
import style0 from "./BaseTextField.vue?vue&type=style&index=0&id=380fb470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380fb470",
  null
  
)

export default component.exports